import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

export interface ICustomPaginationProps {
  totalRows: number;
  pageSizeOptions: number[];
  paginationModel: { page: number; pageSize: number };
  setPaginationModel: Dispatch<
    SetStateAction<{ page: number; pageSize: number }>
  >;
}

export const CustomPagination = ({
  totalRows,
  pageSizeOptions,
  paginationModel,
  setPaginationModel,
}: ICustomPaginationProps) => {
  const pageCount = Math.max(
    1,
    Math.ceil((totalRows || 0) / paginationModel.pageSize)
  );

  return (
    <Stack
      direction={"row"}
      justifyContent={"flex-end"}
      sx={{ width: "90%", padding: "20px 0 10px 0" }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {totalRows > 0 && (
          <Typography
            variant="body2"
            sx={({ palette }) => ({
              fontSize: "14px",
              marginRight: "20px",
              borderRight: "1px solid",
              borderColor: palette.secondary.light,
              paddingRight: "20px",
              lineHeight: "38px",
              fontWeight: "bold",
            })}
          >
            Total Rows: {totalRows}
          </Typography>
        )}
        <Box
          sx={{
            minWidth: 120,
            marginLeft: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ display: "inline", marginRight: 1 }}
          >
            Rows per page:
          </Typography>
          <FormControl
            size="small"
            sx={{ minWidth: 50 }}
          >
            <Select
              labelId="rows-per-page-label"
              value={paginationModel.pageSize}
              label=""
              onChange={(e) => {
                setPaginationModel({
                  page: 0,
                  pageSize: Number(e.target.value),
                });
              }}
              sx={{
                textTransform: "capitalize",
              }}
            >
              {pageSizeOptions.map((size) => (
                <MenuItem
                  key={size}
                  value={size}
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Pagination
          color="primary"
          count={pageCount}
          page={paginationModel.page + 1}
          onChange={(_, value) =>
            setPaginationModel((prev) => ({ ...prev, page: value - 1 }))
          }
          sx={{ marginRight: 2 }}
        />
      </Box>
    </Stack>
  );
};

export default CustomPagination;
